/* ==========================================================================
   Scrollposition beim Zurueckgehen wiederherstellen (MaxiBricks, 25.10.2026)

   Problem: wer auf dem Handy weit in eine Kategorie hineingescrollt hat, ein
   Set oeffnet und dann zurueckgeht, landet wieder ganz oben und muss die
   halbe Seite erneut durchscrollen. Das kostet Kaeufer.

   Normalerweise erledigt der Browser das selbst. Hier tut er es nicht
   zuverlaessig, und das hat einen nachweisbaren Grund: auf der Startseite
   laedt die SEO-App base.css verzoegert (snippets/seoant-defer-css.liquid
   setzt media="print" und schaltet erst nach dem Laden auf "all"). In dem
   Moment, in dem der Browser die Scrollposition wiederherstellen will, ist
   die Seite also noch ungestylt und damit voellig anders hoch. Die
   wiederhergestellte Position passt danach nicht mehr. Dazu kommen
   App-Skripte, die den Rueckwaerts-Cache (bfcache) blockieren koennen - was
   davon im Einzelfall greift, laesst sich von aussen nicht sehen.

   Deshalb hier eine Loesung, die unabhaengig von der Ursache funktioniert:
   die Position wird beim Verlassen gemerkt und beim Zurueckgehen so lange
   nachgeregelt, bis das Layout steht.

   Drei Entscheidungen, die wichtig sind:

   1. Gemerkt wird bei "pagehide", nicht bei "unload". Ein unload-Handler
      verhindert den bfcache des Browsers - wir wuerden also genau das
      kaputt machen, was wir reparieren wollen. Auf iOS feuert unload
      ausserdem oft gar nicht.

   2. Kommt die Seite aus dem bfcache (event.persisted), wird nichts getan.
      Dann hat der Browser die Position bereits korrekt gesetzt, und ein
      zweites Scrollen waere ein sichtbarer Ruck.

   3. Nachgeregelt wird in kurzen Takten ueber anderthalb Sekunden statt
      einmalig. Einmaliges Scrollen schlaegt fehl, solange die Seite noch
      nicht ihre endgueltige Hoehe hat - der Browser kappt den Wert dann auf
      das aktuelle Seitenende. Sobald der Nutzer selbst scrollt, wischt oder
      eine Taste drueckt, bricht die Regelung sofort ab: niemand soll gegen
      die Seite ankaempfen muessen.

   Eingebunden ueber sections/mb-scrollposition.liquid in der Kopfzeilen-
   Gruppe, laeuft damit auf jeder Seite des Shops.
   ========================================================================== */
(function () {
  'use strict';

  var PRAEFIX = 'mbScroll:';
  // Unter 80 px lohnt sich das Wiederherstellen nicht - da ist der Nutzer
  // praktisch noch oben, und ein Sprung waere irritierender als hilfreich.
  var MINDEST = 80;
  var DAUER = 1500;
  var TAKT = 80;

  function schluessel() {
    return PRAEFIX + window.location.pathname + window.location.search;
  }

  function merken() {
    try {
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      if (y > MINDEST) {
        sessionStorage.setItem(schluessel(), String(Math.round(y)));
      } else {
        sessionStorage.removeItem(schluessel());
      }
    } catch (e) {
      /* Privates Fenster oder gesperrter Speicher - dann eben nicht. */
    }
  }

  window.addEventListener('pagehide', merken);

  // Faengt den Fall ab, dass das Handy die Seite im Hintergrund verwirft,
  // ohne dass pagehide noch durchkommt.
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') merken();
  });

  function istZurueck() {
    try {
      var eintraege = window.performance.getEntriesByType('navigation');
      if (eintraege && eintraege.length) return eintraege[0].type === 'back_forward';
    } catch (e) {
      /* faellt unten auf die alte API zurueck */
    }
    return !!(window.performance && window.performance.navigation && window.performance.navigation.type === 2);
  }

  function wiederherstellen() {
    var ziel;
    try {
      ziel = parseInt(sessionStorage.getItem(schluessel()), 10);
    } catch (e) {
      return;
    }
    if (!ziel || ziel < MINDEST) return;

    var laeuft = true;

    function abbrechen() {
      laeuft = false;
      window.removeEventListener('wheel', abbrechen);
      window.removeEventListener('touchstart', abbrechen);
      window.removeEventListener('keydown', abbrechen);
    }

    window.addEventListener('wheel', abbrechen, { passive: true });
    window.addEventListener('touchstart', abbrechen, { passive: true });
    window.addEventListener('keydown', abbrechen);

    var start = Date.now();

    (function takt() {
      if (!laeuft) return;
      if (Math.abs((window.scrollY || 0) - ziel) > 2) {
        window.scrollTo(0, ziel);
      }
      if (Date.now() - start < DAUER) {
        window.setTimeout(takt, TAKT);
      } else {
        abbrechen();
      }
    })();
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) return;
    if (!istZurueck()) return;
    wiederherstellen();
  });
})();
